<template>
  <footer>
    <div class="col-12 row">
      <div class="left-col offset-2 col-4">
        <div class="itware">
          <a href="https://www.itware.hu" target="_blank"> <img alt="FLEETware – járműkövető szolgáltatás - ITware logo" src="../../../public/img/itware_logo.png" class="footer-logo">
          </a>
          <div>
          <p class="small" v-html="$t('footer.contact_html')"></p>
          </div>
        </div>
      </div>
      <div class="right-col offset-1 col-4 last">
        <div class="c10">
          <div class="menu" id="secondarymenu">
            <div class="menu">
              <div>
                <a href="https://www.fleetware.hu/megoldasaink/">{{ $t('footer.solutions') }}</a> |
                <a href="https://www.fleetware.hu/szemelyauto/">{{ $t('footer.car') }}</a> |
                <a href="https://www.fleetware.hu/teherauto/">{{ $t('footer.truck') }}</a> |
                <a href="https://www.fleetware.hu/munkagep/">{{ $t('footer.machinery') }}</a> |
                <a href="https://www.fleetware.hu/hogyan-mukodik/#beszereles">{{ $t('footer.setup') }}</a> |
                <a href="https://www.fleetware.hu/rolunk">{{ $t('footer.about') }}</a>
              </div>
              <div>
                <a href="https://www.fleetware.hu/kapcsolat">{{ $t('footer.contact') }}</a> |
                <a href="https://www.fleetware.hu/wp-content/uploads/2023/10/FLEETware_ASZF.pdf">{{ $t('footer.terms') }}</a> |
                <a href="https://www.fleetware.hu/wp-content/uploads/2023/10/FLEETware_adatkezelesi_tajekoztato.pdf">{{ $t('footer.data_handling') }}</a> |
                <a href="https://www.fleetware.hu/impresszum">{{ $t('footer.impressum') }}</a>
              </div>
            </div>
          </div>
          <p class="copyright">
              © <script>document.write(new Date().getFullYear())</script> - FLEETware.hu
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="scss">
footer {
  margin-top: 40px;
  background-color: #ececec;

  .footer-logo {
    padding-top: 20px;
    padding-right: 20px;
    width: 120px;
    float: left;
  }

  .itware {
    background-color: white;
    margin: 10px;
  }

  p.small {
    display: inline-block;
    font-size: 12px;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 10px;
  }

  .last {
    margin-right: 0 !important;
  }

  .menu {
    margin: 0px auto;
    color: #919191;
  }

  #secondarymenu {
    .menu {
      text-align: right;
      font-size: 12px;

      a {
        color: #919191;
        transition: all linear 0.15s;
      }
    }
  }

  .c10 {
    margin: 10px;
  }

  p.copyright {
    text-align: right;
    font-size: 11px;
    margin-bottom: 5px;
  }
}

@media(max-width: 1750px) {
  footer {
    .left-col {
      max-width: 35%;
      flex: 0 0 35%;
    }
  }
}

@media(max-width: 1625px) {
  footer {
    .left-col {
      max-width: 35%;
      flex: 0 0 35%;
      margin-left: 15%;
    }

    .right-col {
      flex: 0 0 35%;
      max-width: 35%;
    }
  }
}

@media(max-width: 1560px) {
  footer {
    .left-col {
      max-width: 35%;
      flex: 0 0 39%;
      margin-left: 14%;
    }

    .right-col {
      flex: 0 0 37%;
      max-width: 37%;
    }
  }
}

@media(max-width: 1500px) {
  footer {
    .left-col {
      max-width: 40%;
      flex: 0 0 40%;
      margin-left: 13%;
    }

    .right-col {
      flex: 0 0 38%;
      max-width: 38%;
    }
  }
}

@media(max-width: 1462px) {
  footer {
    .left-col {
      max-width: 38%;
      flex: 0 0 38%;
      margin-left: 12%;
    }

    .right-col {
      flex: 0 0 39%;
      max-width: 39%;
    }
  }
}

@media(max-width: 1410px) {
  footer {
    .left-col {
      max-width: 40%;
      flex: 0 0 40%;
      margin-left: 10%;
    }

    .right-col {
      flex: 0 0 40%;
      max-width: 40%;
    }
  }
}

@media(max-width: 1320px) {
  footer {
    .left-col {
      max-width: 43%;
      flex: 0 0 43%;
      margin-left: 5%;
    }

    .right-col {
      flex: 0 0 43%;
      max-width: 43%;
    }
  }
}

@media(max-width: 1223px) {
  footer {
    .left-col {
      max-width: 46%;
      flex: 0 0 46%;
      margin-left: 0;
    }

    .right-col {
      margin-left: 0;
      flex: 0 0 48%;
      max-width: 48%;
    }
  }
}

@media(max-width: 1144px) {
  footer {
    .left-col {
      max-width: 48%;
      flex: 0 0 48%;
      margin-left: 0;
    }

    .right-col {
      margin-left: 0;
      flex: 0 0 48%;
      max-width: 48%;
      padding-right: 0;
    }
  }
}

@media(max-width: 1100px) {
  footer {
    .left-col {
      max-width: 52%;
      flex: 0 0 52%;
      margin-left: 0;
    }

    .right-col {
      margin-left: 0;
      flex: 0 0 40%;
      max-width: 40%;
      padding-right: 0;
    }
  }
}

@media(max-width: 768px) {
  footer {
    .left-col {
      max-width: 100%;
      width: 100%;
      flex: none;
    }

    .right-col {
      max-width: 100%;
      width: 100%;
      flex: none;
    }
  }
}
</style>
